// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/cofre/analiseFiscal.ts
//  Tipos da análise fiscal do Cofre Fiscal (CofreAnaliseService na API). A mesma
//  resposta serve ao Portal do Contador e à Central Fiscal do cliente no ERP.
// ════════════════════════════════════════════════════════════════════════════

/** CofreSentido: 0 = entrada, 1 = saída. */
export type SentidoCofre = 0 | 1;

export interface ReceitaMes { competencia: number; receita: number; devolucoes: number; liquida: number }

export interface SimplesNacional {
  aplicavel: boolean;
  observacao?: string | null;
  crt?: number | null;
  anexo: number;
  nomeAnexo: string;
  anexoSugerido: number;
  motivoSugestao: string;
  receitaMes: number;
  rbt12: number;
  mesesComDados: number;
  faixa: number;
  aliquotaNominal: number;
  parcelaDeduzir: number;
  aliquotaEfetiva: number;
  dasEstimado: number;
  alertaLimite?: string | null;
  historico: ReceitaMes[];
}

export interface AlertaFiscal {
  tipo: string;
  titulo: string;
  orientacao: string;
  quantidade: number;
  exemplos: { documentoId: number; modelo: number; numero: number; detalhe: string }[];
}

export interface AnaliseFiscal {
  competencia: number;
  simples: SimplesNacional;
  cfop: { sentido: SentidoCofre; cfop?: string | null; documentos: number; itens: number; valor: number; baseIcms: number; icms: number; st: number; ipi: number }[];
  cstIcms: { sentido: SentidoCofre; cst?: string | null; itens: number; valor: number; baseIcms: number; icms: number; st: number }[];
  pisCofins: { sentido: SentidoCofre; cstPis?: string | null; cstCofins?: string | null; itens: number; valor: number; pis: number; cofins: number }[];
  ncm: { ncm?: string | null; descricao?: string | null; cstIcms?: string | null; cstPis?: string | null; itens: number; valor: number }[];
  alertas: AlertaFiscal[];
}

export const ANEXOS_SIMPLES: Record<number, string> = {
  1: 'Anexo I — Comércio',
  2: 'Anexo II — Indústria',
  3: 'Anexo III — Serviços',
  4: 'Anexo IV — Serviços (construção, limpeza, vigilância…)',
  5: 'Anexo V — Serviços (Fator R)',
};
